// Styles
import './sort.scss';

// Libs
import React, { useMemo } from 'react';

// Blocks
import Products from '@/ebat/components/abstract/Products/Products';
import SortOptions from '@/ebat/constants/sort';

import {
  RelatedProductsDefaultProps,
  RelatedProductsPropTypes,
} from './RelatedProducts.proptypes';

const RelatedProducts = ({
  className,
  disabled,
  isLoading,
  id,
  related,
  title,
}) => {
  const classNames = useMemo(
    () => ['related-products', className].filter((val) => val).join(' '),
    [className],
  );

  const { PRODUCTS_LIST } = SortOptions();

  return (
    <div className={classNames} id={id}>
      <div className="wrapper">
        <h2 className="h2">{title}</h2>
        <Products
          localOptions={PRODUCTS_LIST}
          products={related}
          productType="list"
          disabled={disabled || isLoading}
          isLoading={isLoading}
        />
      </div>
    </div>
  );
};

RelatedProducts.defaultProps = {
  ...RelatedProductsDefaultProps,
};

RelatedProducts.propTypes = {
  ...RelatedProductsPropTypes,
};

export default RelatedProducts;
